import * as React from 'react';
import SurveyLoading from '../components/SurveyLoading';

export const Loading: React.FunctionComponent = () => {
  return <SurveyLoading />;
};
